import axios from "../axios/index.js";

const urlGetMaterialList = "/api/material/get-list";
const urlGetMaterialListWithType = "/api/material/get-list-with-type";

export default {
    getList(params) {
        return axios.post(urlGetMaterialList, params);
    },

    getMaterialWithType(params) {
        return axios.post(urlGetMaterialListWithType, params);
    },
};
